export enum ProductFeePayment {
  /** Commencement */
  COMMENCEMENT = 'C',
  /** Monthly */
  MONTHLY = 'M',
  /** Yearly */
  YEARLY = 'Y'
}
